export const ProposalText = {
  title: 'Submit a Proposal',
  description:
    'If your company falls into one of the above categories and you are looking for a new partner, fill out the form below:',
};
